export const version = "wordlists/5.8.0";
